import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import InternContainerComponent from './InternContainerComponent';
import cambridgeInternList from './CecTeam';
import UserInfoContainer from './UserInfoContainer';
import {connect} from 'react-redux';
import store, {cecPageNo, twaPageNo, mbaPageNo, schoolPageNo, collegePageNo} from '../../../redux/store';

// ES6 classNameNameNameName-style
class CambridgeComponent extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.state = {
			profileData: null,
			userClicked: false
		}

	}
	componentDidMount() {
		this.setState({ profileData: null, userClicked: false });
	}
	hideFn = (profileData) => {
		this.setState({ profileData: profileData, userClicked: true });
	}
	closeFn = () => {
		this.setState({ profileData: null, userClicked: false });
	}
	render() {
		return (
			<div>
				<div className="header">
					<p>From metropolitan Singapore through the lush rainforests of Colombia to the Highveld of South Africa, HeyMath's products support the work of teachers and help students build a strong foundation in Maths and Science.</p>
					<p>If you have a passion for Maths and Science, are a self-driven individual who thrives on challenges, travel and adventure, we are looking for you! We offer you the opportunity to live and work in Chennai, India (minimum commitment of a year) to experience our dynamic and vibrant culture.</p>
					<p>From developing creative resources to building apps to running teacher workshops and student activities, there is never a dull moment at HeyMath! Our work atmosphere is collegiate, open, non-heirarchichal and meritocratic.</p>
					<p>So, come and experience working in a fast-paced product company, explore your ideas, take ownership from day one and get paid to learn about new exciting developments in Education and Technologies in diverse geographies!</p>
					<p>This is what Cambridge graduates, over the years, had to say about their experiences about work and life in India.</p>
				</div>
				{
					(() => {
						if (this.state.userClicked) {
							return (
								<UserInfoContainer userData={this.state.profileData} closeFn={this.closeFn}></UserInfoContainer>
							)
						}
					})()
				}
				{
					(() => {
						if (!this.state.userClicked) {
							return (
								<InternContainerComponent getPageValue={this.props.getPageValue} decrementFn={this.props.decrementFn} incrementFn={this.props.incrementFn} profileClickedFn={this.hideFn} internList={cambridgeInternList}></InternContainerComponent>
							)
						}
					})()
				}
			</div>
		);
	}
}

const getStateData = (state) => {
    return {
        getPageValue:()=>{
			//console.log("removeData ");
			return state.cecPageNo
		}
    }
}

const setStateData = (dispatch) => {
    return {
        incrementFn:()=>{
            //console.log("addData ",addData);
            dispatch({type:"cec_pageno_increment"})
        },
        decrementFn:()=>{
            //console.log("removeData ");
            dispatch({type:"cec_pageno_decrement"})
        }
    }
}

export default connect(getStateData,setStateData) (CambridgeComponent);


// WEBPACK FOOTER //
// ./src/prelogin/src/components/CambridgeComponent.js